import auth from '../auth/reducer';
import browser from '../browser/reducer';
import { reducer as debugReducer } from '../debug/reducer';
import { reducer as meta } from '../meta/reducer';
import { reducer as beheer } from '../admin/reducer';
import { reducer as admin } from '../note/admin/reducer';
import { beheerBatch, beheerEditor, beheerResource } from '../admin/resource';
import { reducer as notesReducer } from '../note/notes/reducer';
import { bookmarksBatch, bookmarksEditor, bookmarksResource } from '../note/bookmarks/resource';
import { categoriesBatch, categoriesEditor, categoriesResource } from '../note/categories/resource';
import { participantsBatch, participantsEditor, participantsResource } from '../participant/resource';
import { notesSharedBatch, notesSharedEditor, notesSharedResource } from '../note/noteshared/resource';
import { emailArchiveResource, emailArchiveEditor, emailArchiveBatch } from '../emailarchive/emails/resource';
import { questionsBatch, questionsEditor, questionsResource } from '../note/question/resource';

import categorySelectPopup from '../note/categorySelectPopup/reducer';
import noteParticipantSelectPopup from '../note/noteParticipantSelectPopup/reducer';
import { reducer as filter } from '../note/filter/reducer';
import { reducer as flyover } from '../note/flyover/reducer';
import { reducer as noteLocator } from '../note/locator/reducer';
import { reducer as notemenu } from '../note/notemenu/reducer';
import { notesBatch, notesEditor, notesResource } from '../note/notes/resource';
import { reducer as pageFilter } from '../note/pageFilter/reducer';
import { reducer as selection } from '../note/selection/reducer';
import { reducer as statusDialog } from '../note/statusDialog/reducer';
import window from '../window/reducer';
import { reducer as batchdelete } from '../emailarchive/emails/reducer';
import { reducer as participant} from '../participant/reducer';
import { useridResource, useridEditor, useridBatch } from '../participantid/resource';
import { reducer as participantid } from '../participantid/reducer';
import { reducer as usergroup} from '../usergroup/reducer';
import { usergroupBatch, usergroupEditor, usergroupResource } from '../usergroup/resource';
import { notechatBatch, notechatEditor, notechatResource } from '../note/notechat/resource';
import { reducer as notechat } from '../note/notechat/reducer';
import { reducer as questionaddressee } from '../questionaddressee/reducer';
import { questionaddresseeBatch, questionaddresseeEditor, questionaddresseeResource } from '../questionaddressee/resource';
import { reducer as questionReducer } from '../note/question/reducer';

const debug = process.env.NODE_STAGE === 'test' || process.env.NODE_STAGE === 'productie' ? {} : {debug: debugReducer };
 
export const reducer = {
    ...debug,
    admin,
    beheer,
    beheerBatch: beheerBatch.reducer,
    beheerEditor: beheerEditor.reducer,
    beheerResource: beheerResource.reducer,
    auth,
    emailarchiveBatch: emailArchiveBatch.reducer,
    emailarchiveEditor: emailArchiveEditor.reducer,
    emailarchiveResource: emailArchiveResource.reducer,
    bookmarksBatch: bookmarksBatch.reducer,
    bookmarksEditor: bookmarksEditor.reducer,
    bookmarksResource: bookmarksResource.reducer,
    browser,
    categoriesBatch: categoriesBatch.reducer,
    categoriesEditor: categoriesEditor.reducer,
    categoriesResource: categoriesResource.reducer,
    categorySelectPopup,
    filter,
    flyover,
    meta,
    noteLocator,
    notechatBatch: notechatBatch.reducer, 
    notechatEditor: notechatEditor.reducer, 
    notechatResource: notechatResource.reducer,
    notechat,  
    notemenu,
    notesReducer,
    notesBatch: notesBatch.reducer,
    notesEditor: notesEditor.reducer,
    notesResource: notesResource.reducer,
    notesSharedBatch: notesSharedBatch.reducer,
    notesSharedEditor: notesSharedEditor.reducer,
    notesSharedResource: notesSharedResource.reducer,   
    pageFilter,
    selection,
    statusDialog,
    window,
    batchdelete,
    participantBatch: participantsBatch.reducer,
    participantEditor: participantsEditor.reducer,
    participantResource: participantsResource.reducer,    
    participantidResource: useridResource.reducer, 
    participantidEditor: useridEditor.reducer, 
    participantidBatch: useridBatch.reducer, 
    participantid,   
    participant,
    questionaddresseeBatch: questionaddresseeBatch.reducer,
    questionaddresseeEditor: questionaddresseeEditor.reducer,
    questionaddresseeResource: questionaddresseeResource.reducer,      
    questionaddressee,
    questionsBatch: questionsBatch.reducer,
    questionsEditor: questionsEditor.reducer,
    questionsResource: questionsResource.reducer,
    questionReducer,
    noteParticipantSelectPopup,
    usergroupBatch: usergroupBatch.reducer,
    userGroupEditor: usergroupEditor.reducer,
    userGroupResource: usergroupResource.reducer,        
    usergroup,
};



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/store/reducer.tsx